import React, { useState, useEffect } from "react";
import '../../assets/css/checkout.css';
import Breadcrumb from "../Layout/Breadcrumb";
import { Link } from "react-router-dom";
import { Button } from 'react-bootstrap';
import CustomerModalbox from "../Common/CustomerModalbox";
import ITooltip from "../Common/ITooltip";
import CartModal from "../Common/CartModal";
import Skeleton from 'react-loading-skeleton';  // Import skeleton
import toast, { Toaster } from 'react-hot-toast';

function CheckOut() {
  const notify = () => toast.error('Delet This Data File');
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState('');
  const [loading, setLoading] = useState(true);  // Set loading state
  const handleImageClick = (imageUrl) => {
    setModalImage(imageUrl);
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);
  useEffect(() => {
    // Simulate loading time (you can replace this with actual data fetching)
    setTimeout(() => {
      setLoading(false);
    }, 2000);  // 2 seconds delay to simulate loading
  }, []);

  return (
    <>
    <Breadcrumb/> 
      <div className="TableBoxCheckout" style={{ marginTop: "30px", background: "#FFF"}}>
        <div className="container">
          <div className="row">
            <div className="col-md-9">
              <div className="table-box-content">
                <div className="table-responsive">
                  <table className="table table-lg table-boxrto mb-0" style={{ width: "100%" }}>
                    <thead className="text-center">
                      <tr>
                        <th className="table-header" width="75">Image</th>
                        <th className="table-header">Design & Shade</th>
                        <th className="table-header">Size</th>
                        <th className="table-header">Stock</th>
                        <th className="table-header">Qty.</th>
                        <th className="table-header">GST%</th>
                        <th className="table-header">
                          MRP (<i className="bi bi-currency-rupee"></i>)
                        </th>
                        <th className="table-header">Amount</th>
                        <th className="table-header" width="90">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        // Skeleton loader for each row
                        <>
                          <tr>
                            <td><Skeleton height={70} width={50} /></td>
                            <td><Skeleton height={20} width={150} /></td>
                            <td><Skeleton height={20} width={50} /></td>
                            <td><Skeleton height={20} width={50} /></td>
                            <td><Skeleton height={30} width={80} /></td>
                            <td><Skeleton height={20} width={40} /></td>
                            <td><Skeleton height={20} width={80} /></td>
                            <td><Skeleton height={20} width={80} /></td>
                            <td><Skeleton height={30} width={50} /></td>
                          </tr>
                          <tr>
                            <td><Skeleton height={70} width={50} /></td>
                            <td><Skeleton height={20} width={150} /></td>
                            <td><Skeleton height={20} width={50} /></td>
                            <td><Skeleton height={20} width={50} /></td>
                            <td><Skeleton height={30} width={80} /></td>
                            <td><Skeleton height={20} width={40} /></td>
                            <td><Skeleton height={20} width={80} /></td>
                            <td><Skeleton height={20} width={80} /></td>
                            <td><Skeleton height={30} width={50} /></td>
                          </tr>
                        </>
                      ) : (
                        // Normal content when loading is finished
                        <>
                          <tr>
                            <td className="align-middle" width="75">
                              <img
                                className="img-fluid"
                                style={{ fontSize: "13px", padding: "3px", width: "50px", height: "auto" }}
                                src="https://www.bellagiohome.in/wp-content/uploads/2019/03/red-carpet.jpg"
                                alt="product"
                                onClick={() => handleImageClick("https://www.bellagiohome.in/wp-content/uploads/2019/03/red-carpet.jpg")}
                              />
                            </td>
                            <td className="align-middle" width="215">
                              <Link to="/" style={{ fontSize: "12px" }}>
                                 Red Carpet
                              </Link>
                            </td>
                            <td className="align-middle text-center">40X60</td>
                            <td className="align-middle text-center">155</td>
                            <td className="align-middle text-center">
                              <select className="form-control form-control-sm text-center">
                                <option value="0">0</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                              </select>
                            </td>
                            <td className="align-middle text-center">12.00</td>
                            <td className="align-middle text-center">550.00</td>
                            <td className="align-middle text-center">550.00</td>
                            <td className="align-middle text-center">
                              <div className="customer-selected-cart">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-secondary addtocart"
                                  title="Add to Cart"
                                  onClick={notify}
                                >
                                  <i className="spinner-border spinner-border-sm d-none" id="spinner_31185"></i>
                                  <i className="bi bi-trash"></i>
                                </button>
                                <Toaster />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="align-middle" width="75">
                              <img
                                className="img-fluid"
                                style={{ fontSize: "13px", padding: "3px", width: "50px", height: "auto" }}
                                src="https://www.bellagiohome.in/wp-content/uploads/2019/03/red-carpet.jpg"
                                alt="product"
                                onClick={() => handleImageClick("https://www.bellagiohome.in/wp-content/uploads/2019/03/red-carpet.jpg")}
                              />
                            </td>
                            <td className="align-middle" width="215">
                              <Link to="/" style={{ fontSize: "12px" }}>
                                Red Carpet
                              </Link>
                            </td>
                            <td className="align-middle text-center">40X60</td>
                            <td className="align-middle text-center">155</td>
                            <td className="align-middle text-center">
                              <select className="form-control form-control-sm text-center">
                                <option value="0">0</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                              </select>
                            </td>
                            <td className="align-middle text-center">12.00</td>
                            <td className="align-middle text-center">550.00</td>
                            <td className="align-middle text-center">550.00</td>
                            <td className="align-middle text-center">
                              <div className="customer-selected-cart">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-secondary addtocart"
                                  title="Add to Cart"
                                  onClick={notify}
                                 >
                                  <i className="spinner-border spinner-border-sm d-none" id="spinner_31185"></i>
                                  <i className="bi bi-trash"></i>
                                </button>
                                <Toaster/>
                              </div>
                            </td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-md-3">
       
              <div className="box-amount">
                <CustomerModalbox />
                {loading ? ( 
                  <>
                   <div className="d-flex">
                  <span> <Skeleton height={20} width={75} /> </span>
                  <div className="ml-auto">
                    <span className="update-qty"> <Skeleton height={20} width={75} /> </span>
                  </div>
                </div>

                <div className="d-flex">
                  <span> <Skeleton height={20} width={75} /> </span>
                  <div className="ml-auto">
                    <span className="update-qty"> <Skeleton height={20} width={75} /> </span>
                  </div>
                </div>

                <div className="d-flex">
                  <span> <Skeleton height={20} width={75} /> </span>
                  <div className="ml-auto">
                    <span className="update-qty"> <Skeleton height={20} width={75} /> </span>
                  </div>
                </div>

                <div className="d-flex">
                  <span> <Skeleton height={20} width={75} /> </span>
                  <div className="ml-auto">
                    <span className="update-qty"> <Skeleton height={20} width={75} /> </span>
                  </div>
                </div>
                  
                  </>
                  
                ):(

                 <>
                <div className="d-flex">
                  <span>  Qty. </span>
                  <div className="ml-auto">
                    <span className="update-qty">2</span>
                  </div>
                </div>

                <div className="d-flex">
                  <span>Taxable Value</span>
                  <div className="ml-auto">
                    <span className="update-qty">
                      <i className="bi bi-currency-rupee"></i>1249.54
                    </span>
                  </div>
                </div>

                <div className="d-flex">
                  <span>GST Amount</span>
                  <div className="ml-auto">
                    <span className="update-qty">
                      <i className="bi bi-currency-rupee"></i>195.00
                    </span>
                  </div>
                </div>

                <div className="d-flex">
                  <span>Total Amount</span>
                  <div className="ml-auto">
                    <span className="update-qty">
                      <i className="bi bi-currency-rupee"></i>1445
                    </span>
                  </div>
                </div>

                <div
                  className="d-flex align-items-center"
                  style={{
                    borderTop: "1px solid #d9cfcf",
                    borderBottom: "1px solid #d9cfcf",
                    padding: "6px 0"
                  }}
                >
                  <div style={{ display: "inline-flex", width: "300px" }}>
                    <ITooltip />
                    &nbsp; Avail. Points: <span id="rpoint">0</span>
                  </div>

                  <div id="r-point" className="ml-auto mb-0">
                    {/* <div className="input-group input-group-sm">
                      <input
                        type="text"
                        className="form-control border-warning shadow-none"
                        aria-label="Redeem points"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-warning apply" type="button" style={{ background: "#000", color:"#FFF"}}>
                          Apply
                        </button>
                      </div>
                    </div> */}
                  </div>
                </div>
                </>
                )}
                <Button className="btn btnyellow mt-1" style={{ borderRadius: "0"}}> PROCEED TO CHECKOUT </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Cart Image Modal */}

      <CartModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalImage={modalImage}
      />

    </>
  );
}

export default CheckOut;
